<div class="booble-backdrop">
    <div class="booble-modal">
        <div class=" xp-modal xp-modal-cadastro">
            <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="icon"><img src="./assets/image/icon-m-global-sec.png"></div>
                        <button type="button" (click)="closeModal()" class="btn-close" data-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="modal-dialog-scrollable-general">
                            <div>
                                <h5>Tem certeza que deseja cancelar a edição do cadastro?</h5>
                            </div>
                        </div>
                        <div class="cadastro-line-btn">
                            <div class="form-row">
                                <div class="cols">
                                    <div class="form-group">
                                        <button type="button" (click)="closeModal()" class="btn-xp-m2 btn-blue-30-b">
                                            Não
                                        </button>
                                    </div>
                                </div>
                                <div class="cols">
                                    <div class="form-group mb-0">
                                        <button type="button" (click)="goHome()" class="btn-xp-m2 btn-blue-30">
                                            Sim
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
